import { ReturnAssessmentDefinitionSchema } from "@redotech/redo-return-core-common/return-assessments/assessment-schemas";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getAssessmentDefinition = {
  name: "getAssessmentDefinition" as const,
  input: z.object({ definitionId: zExt.objectId() }),
  output: z.object({ definition: ReturnAssessmentDefinitionSchema.nullable() }),
};
